<template>
  <div class="my-4">
    <v-list-item
      v-if="!hideTitle"
      class="simple title"
      style="z-index: 2;"
      :class="(isValid ? color : 'error') + '--text'"
      :aria-expanded="String(show)"
      :disabled="disabled"
      @click="$emit('input', show ? value.filter(x => x != title) : multiple ? [ ...value, title ] : [ title ])"
    >
      <v-progress-circular v-if="loading" indeterminate size="24" width="2" />
      <v-icon v-else v-html="icon" />
      <div class="d-flex align-center" style="margin-left: 0 !important;">
        <slot name="title">{{title}}</slot>
        <v-icon v-if="!disabled" class="menu-down" style="vertical-align: top;" v-html="mdiMenuDown" />
      </div>
    </v-list-item>
    <v-expand-transition>
      <v-form
        ref="form"
        v-show="show && !loading"
        v-bind:class="{ offset }"
        lazy-validation
        @submit.prevent
        v-model="isValid"
      >
        <div class="pt-3 pb-6" style="z-index: 1;">
          <slot></slot>
        </div>
      </v-form>
    </v-expand-transition>
  </div>
</template>


<style scoped>
.offset {
  max-width: 600px;
  margin: 0 16px 0 48px;
}
</style>


<script>
import { mdiMenuDown } from '@mdi/js';

export default {
  name: 'title-toggle',

  props: {
    title: String,
    icon: String,
    error: Boolean,
    disabled: Boolean,
    multiple: Boolean,
    value: Array,
    offset: { type: Boolean, default: true },
    hideTitle: Boolean,
    color: { type: String, default: 'ec-dark-blue' },
    loading: Boolean
  },

  data() {
    return {
      isValid: true
    };
  },

  created() {
    Object.assign(this, { mdiMenuDown });
  },

  computed: {
    show() {
      return this.value.includes(this.title);
    }
  },

  watch: {
    show(v) {
      if (!v)
        this.$refs.form.validate();
    }
  }
}
</script>
